<template>
  <div>
    <landing-main />
  </div>
</template>

<script>
import LandingMain from "../components/LandingMain";

export default {
  name: "Home",

  components: {
    LandingMain,
  },
  created() {
    document.title = "SODABA | Welcome";
  },
};
</script>
